import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import mitt from 'mitt'

// Importaciones de Bootstrap - Se cargan primero para que nuestros temas puedan sobrescribirlos
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue-3/dist/bootstrap-vue-3.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import 'bootstrap-icons/font/bootstrap-icons.css'

// Importar archivo CSS consolidado con todos los estilos
import './assets/styles/main.css'
import AlertService from './shared/utils/alert'
import MgkResponseHandler from './shared/utils/mgk-response-handler'

// Importar y configurar el interceptor de Axios
import setupInterceptors from './services/api-interceptor'

// Configurar interceptores para añadir token a las solicitudes
setupInterceptors()

// Crear el emitter global para eventos
const emitter = mitt()

const app = createApp(App)

// Registrar el servicio de alertas como propiedad global
app.config.globalProperties.$alert = AlertService

// Registrar el manejador de respuestas MgkMessage como propiedad global
app.config.globalProperties.$mgkResponse = MgkResponseHandler

// Registrar el emitter global para eventos
app.config.globalProperties.$emitter = emitter

// Proporcionar los servicios para que estén disponibles en la composición API
app.provide('alert', AlertService)
app.provide('mgkResponse', MgkResponseHandler)
app.provide('emitter', emitter)

app.use(router)
app.mount('#app')
